import { createSlice } from '@reduxjs/toolkit';
import { generateSetEditId } from '../../generators/generateReducers';
import { generateStateSingle } from '../../generators/generateState';
import {
    createData,
    deleteData,
    editData,
    fetchData,
    fetchEditData,
} from '../../generators/generateThunks';
const SLICE_NAME = 'yarnGrade';

export const fetchYarnGrades = fetchData.generateThunk(SLICE_NAME, SLICE_NAME);
export const editYarnGrade = editData.generateThunk(SLICE_NAME, SLICE_NAME);
export const fetchYarnGrade = fetchEditData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);
export const deleteYarnGrade = deleteData.generateThunk(SLICE_NAME, SLICE_NAME);
export const createYarnGrade = createData.generateThunk(SLICE_NAME, SLICE_NAME);

const yarnGradeSlice = createSlice({
    name: SLICE_NAME,
    initialState: generateStateSingle(SLICE_NAME),
    reducers: {
        setEditId: generateSetEditId(),
    },
    extraReducers: {
        ...fetchData.generateExtraReducers(fetchYarnGrades, SLICE_NAME),
        ...createData.generateExtraReducers(createYarnGrade, SLICE_NAME),
        ...deleteData.generateExtraReducers(deleteYarnGrade, SLICE_NAME),
        ...fetchEditData.generateExtraReducers(fetchYarnGrade, SLICE_NAME),
        ...editData.generateExtraReducers(editYarnGrade, SLICE_NAME),
    },
});

export const getYarnGrade = (state) => state.yarnGrade;
export const { setEditId } = yarnGradeSlice.actions;
export default yarnGradeSlice.reducer;
